export default __webpack_public_path__ + "static/media/Gift.bd515d41.svg";